import React from "react";
import { Flex, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function ExtractsList(){
    const colors = useRecoilState(customColors)[0];

    return (
        <Flex w={"100%"} justifyContent={"center"} px={10} mt="50px">
            <TableContainer borderRadius="8px" >
                <Table variant="striped" colorScheme='gray'  overflowY="scroll">
                    <Thead h="60px">
                        <Tr>
                            <Th w={"300px"} borderRadius={"0 0 0 8px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                ID da Venda
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Data da Venda
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Status
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Estabelecimento
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Pagador
                            </Th>
                            <Th w={"300px"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Tipo de Venda
                            </Th>
                            <Th w={"300px"} borderRadius={"0 0 8px 0"} textAlign={"center"} bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                                Valor
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td borderRadius={"8px 0 0 8px"} textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td borderRadius={"0 8px 8px 0"} textAlign={"center"}>teste</Td>
                        </Tr>
                        <Tr>
                            <Td borderRadius={"8px 0 0 8px"} textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td textAlign={"center"}>teste</Td>
                            <Td borderRadius={"0 8px 8px 0"} textAlign={"center"}>teste</Td>
                        </Tr>
                    </Tbody>
                </Table>
            </TableContainer>
        </Flex>
    )
};